import React from 'react';
import { ModalHeader } from '../../../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalFooter } from '../../../../CommonComponents/OPL/Modal/ModalFooter';
import { Button } from '../../../../CommonComponents/OPL/Button/Button';
import { Modal } from '../../../../CommonComponents/OPL/Modal/Modal';
import { Alert } from '../../../../CommonComponents/OPL/Alert/Alert';
import { useSaveAccountMutation } from '../../api/useSaveAccountMutation';
import { AccountDTO, GrantDTO } from '../../../../Profile/Accounts/api/useAccountsQuery';
import { useDeleteAccountMutation } from '../../api/useDeleteAccountMutation';

interface Props {
  clientId: string;
  grant: GrantDTO;
  account: AccountDTO;
  onClose(): void;
  onSuccess?(): void;
}

export const DeleteStockGrantModal = ({ clientId, account, grant, onClose, onSuccess }: Props) => {
  const {
    mutateAsync: deleteStockGrant,
    isLoading: isDeletingStockGrant,
    error: deleteStockGrantError,
  } = useSaveAccountMutation({ clientId });

  const {
    mutateAsync: deleteAccount,
    isLoading: isDeletingAccount,
    error: deleteAccountError,
  } = useDeleteAccountMutation({ clientId });

  const isLoading = isDeletingStockGrant || isDeletingAccount;

  const error = deleteStockGrantError || deleteAccountError;

  const handleDeleteStockGrant = async () => {
    try {
      if (account.GrantList.length === 1) {
        await deleteAccount({ clientId, id: account.AccountId });
      } else {
        await deleteStockGrant({
          clientId,
          account: {
            ...account,
            GrantList: account.GrantList.filter(({ Id }) => Id !== grant.Id),
          },
        });
      }

      onClose();

      if (onSuccess) {
        onSuccess();
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Modal
      isOpen
      onRequestClose={onClose}
      shouldCloseOnOverlayClick={false}
      aria={{ labelledby: 'stock-grant--delete--modal-header' }}
    >
      <ModalHeader as="h2" id="stock-grant--delete--modal-header">
        Are you sure you want to delete this stock grant?
      </ModalHeader>

      {error && <Alert message={error.message} variant="error" mb="16" mx="24" />}

      <ModalFooter>
        <Button variant="subtleInactive" onClick={onClose}>
          Cancel
        </Button>

        <Button variant="error" isLoading={isLoading} onClick={handleDeleteStockGrant} ml="8">
          Delete Stock Grant
        </Button>
      </ModalFooter>
    </Modal>
  );
};
